/* eslint-disable no-undef */
import Types from './Types';

const receivePriceChart = response => {
	return ({
		type: Types.API_CIBC_RECEIVE_PRICECHART,
		response
	});
};

const recieveMultiplePriceChart = response => {
	return ({
		type: Types.API_CIBC_RECEIVE_MULTIPLE_PRICECHART,
		response
	});
};

const handleLoader = fetchName => {
	return ({
		type: Types.API_CIBC_HANDLE_PRICECHART_LOADER,
		fetchName
	});
};

const requestPriceChart = (days, xids, chartHeight, chartWidth,
	includeVolume = false, isMutualFund = false, supressPreviousClose = false, locale = 'en') => {
	const result = {
		type: Types.API_CIBC_SINGLE_REQUEST_PRICECHART,
		endPoint: `/charts/price/${xids}`,
		params: {
			days,
			height: chartHeight,
			width: chartWidth,
			showLastPrice: false,
			includeVolume,
			isMutualFund,
			supressPreviousClose,
			cultureInfo: locale === 'en' ? 'EN-US' : 'FR-CA'
		},
		ajaxType: 'GET',
		onSuccess: response => { return receivePriceChart(response); },
		loader: handleLoader,
		fetchName: 'fetchingPriceChartData'
	};
	return result;
};

const requestMultiplePriceChart = (days, xids, chartHeight, chartWidth,
	includeVolume = false, isMutualFund = false, supressPreviousClose = false, locale = 'en') => {
	const result = {
		type: Types.API_CIBC_REQUEST_PRICECHART,
		endPoint: `/charts/price/${xids}`,
		params: {
			days,
			height: chartHeight,
			width: chartWidth,
			showLastPrice: false,
			includeVolume,
			isMutualFund,
			supressPreviousClose,
			cultureInfo: locale === 'en' ? 'EN-US' : 'FR-CA'
		},
		ajaxType: 'GET',
		onSuccess: response => { return recieveMultiplePriceChart(response); },
		loader: handleLoader,
		fetchName: 'fetchingPriceChartData'
	};
	return result;
};

const requestDailyPriceModChart = symbol => {
	const result = {
		params: {
			apiPath: window.MD.chartworksAPIUrl,
			symbol,
			days: 1,
			rulerIntradayStart: 31,
			rulerIntradayStop: 3,
			rulerInterdayStart: 12783,
			rulerInterdayStop: 10,
			dataPeriod: 'Minute',
			yAxisSide: 'left',
			showMarketCloseLabels: 'all',
			style: {
				panel: {
					border: {
						default: { color: null },
						left: { color: '#dddddd', width: 1 },
						bottom: { color: '#dddddd', width: 1 }
					},
					grid: {
						width: 0
					},
					yAxis: {
						label: {
							format: {
								default: {
									format: '0,.2f'
								}
							}
						}
					},
					padding: {
						bottom: 0
					},
					margin: {
						bottom: 80
					}
				},
				indicator: {
					price: {
						color: '#68a2ca',
						background: {
							color: '#c0d8e9',
							colorStop: 'white'
						},
						width: 1.5
					}
				}
			}
		},
		panels: [{
			indicators: [{
				id: 'price',
				markerType: 'fill'
			}]
		}]
	};
	return result;
};

export {
	requestPriceChart,
	requestMultiplePriceChart,
	receivePriceChart,
	requestDailyPriceModChart
};
